import { Email, Language, LinkedIn, LocationOn } from '@mui/icons-material';
import { Box, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import sgfin_logo from '../assets/logos/NUS_SGFIN_logo.png';
import AppHeader from "../components/nav/AppHeader";
import BottomNav from "../components/nav/BottomNav";
import { sendReactGAPageView } from "../consts/helpers";

export default function AboutSGFIN() {
    const navigate = useNavigate();
	const { pathname } = useLocation();
	useEffect(() => {
        sendReactGAPageView(pathname, 'About SGFIN');
    }, [pathname])

    return (
        <>
            <AppHeader />

            <Stack spacing={2}>
                <Typography variant="h6">About SGFIN</Typography>

                <img src={sgfin_logo} alt='Sustainable and Green Finance Institute logo'  style={{ maxWidth: '100%' }}/>

                <Typography variant="body2" >
                    The Sustainable and Green Finance Institute (SGFIN) is a research institute established by the National University of Singapore (NUS). SGFIN provides deep research capabilities in sustainable and green finance with the focal point on Asia and contributes thought leadership to shape sustainability outcomes in policymaking across the financial sector and the economy at large.
                </Typography>
                <Typography variant="body2" >
                    Supported by exceptional domain experts across NUS, SGFIN equips businesses with critical knowledge across disciplines to better quantify the environmental and social impacts of their business developments, operations, products, and services. SGFIN also provides education, training, and toolkits to integrate sustainability dynamics into their business strategies and investment decisions. In essence, SGFIN facilitates companies and institutions in embedding sustainability as a core pillar in their business decisions.
                </Typography>

                <Typography variant="subtitle1" >Our Vision</Typography>
                <Typography variant="body2" >
                    <li>
                    To be a leading voice on sustainable enterprises and green finance.
                    </li>
                </Typography>
                <Typography variant="body2" >
                    <li>
                    To facilitate Singapore becoming a hub of sustainable and green finance.
                    </li>
                </Typography>

                <Typography variant="subtitle1" >Our Mission</Typography>
                <Typography variant="body2" >
                    <li>
                    To develop an evidence-based framework of impact measurements of industrial and commercial activities.
                    </li>
                </Typography>
                <Typography variant="body2" >
                    <li>
                    To train and supply talent and leadership on sustainable and green finance practices.
                    </li>
                </Typography>
                <Typography variant="body2" >
                    <li>
                    To be a leading voice on sustainable enterprises and green finance.
                    </li>
                </Typography>
                <Typography variant="body2" >
                    <li>
                    To foster impactful research on sustainable and green finance with a focus on Asia.
                    </li>
                </Typography>
                <Typography variant="body2" >
                    <li>
                    To become a knowledge hub for companies to integrate sustainability into their business practices.
                    </li>
                </Typography>

                <Typography variant="body2" >
                    Find out more about us at <a href="https://sgfin.nus.edu.sg" target='_blank' rel="noopener noreferrer" style={{ color: 'var(--pri-purple)' }}>sgfin.nus.edu.sg</a>!
                </Typography>

                <Stack spacing={1} sx={{ color: '#1976D2', alignItems: 'start' }}>
                    <Box className="centered-x">
                        <LinkedIn/>&ensp;
                        <FooterLink
                            content="https://linkedin.com/company/sustainable-and-green-finance-institute"
                            link="https://linkedin.com/company/sustainable-and-green-finance-institute"
                        />
                    </Box> 
                    <Box className="centered-x">
                        <Email/>&ensp;
                        <FooterLink
                            content="sgfin@nus.edu.sg"
                            link="mailto:sgfin@nus.edu.sg"
                        />
                    </Box> 
                    <Box className="centered-x">
                        <Language/>&ensp;
                        <FooterLink
                            content="https://sgfin.nus.edu.sg"
                            link="https://sgfin.nus.edu.sg"
                        />
                    </Box> 
                    <Box className="centered-x">
                        <LocationOn/>&ensp;
                        <Typography variant="caption" >
                            National University of Singapore
                            Innovation 4.0
                            3 Research Link #02-02
                            Singapore 117602
                        </Typography>
                    </Box> 
                </Stack>
            </Stack>

            <BottomNav />
        </>
    )
}

const FooterLink = ({content, link=''}) => {
    return (
        <Typography variant="caption" >
            {
                link ?
                <a href={link} target='_blank' rel="noopener noreferrer" style={{ color: '#1976D2', textDecoration: 'none' }}>{content}</a>
                :
                <>{content}</>
            }
        </Typography>
    )
}